import { gql } from '@apollo/client';
import { graphql } from '../../graphql';
import { itemsFragment } from '../fragments/items';
import { PASHA_LANDING_SLUG } from '../../utils/helpers/search';

export const getPashaDataQuery = graphql(`
  query LandingBrand($slug: String!) {
    landingBrand(slug: $slug) {
      banners {
        coverUrl
        text
        textColor
        title
        url
        visibleOn
      }
      name
      placements {
        address
        buildingClass {
          name
        }
        coverSlogan
        coverUrl
        deadline
        facilities {
          iconUrl
          name
        }
        lat
        listingType
        lng
        name
        path
        photosUrls
        slogan
        url
      }
    }
  }
`);

export const getPashaItems = gql`
  query PashaItems(
    $limit: Limit!
    $filter: ItemFilter
    $offset: Int!
    $sort: ItemSort!
    $connectionSort: ItemConnectionSort!
  ) {
    items(limit: $limit, filter: $filter, sort: $sort, offset: $offset) {
      ...itemFields
    }
    itemsConnection(filter: $filter, sort: $connectionSort) {
      totalCount
    }
  }
  ${itemsFragment}
`;

export const getPashaFilterDataQuery = gql`
  query GetPashaFilterData {
    categories(
      filter: { scope: NOT_LOT, landingBrandSlug: "${PASHA_LANDING_SLUG}" }
    ) {
      id
      name
      pluralName
      slug
      children {
        id
        name
        pluralName
        slug
      }
    }
    rooms @client {
      id
      slug
      name
    }
    type @client {
      id
      name
    }
    sort @client {
      id
      params
      name
    }
  }
`;
